/* Correzione carosello hero Carraro */
(() => {
  function initHero() {
    const hero = document.querySelector(
      '.carraro-replica .elementor-element-26487302'
    );

    if (!hero || hero.dataset.heroFixed) return;

    const viewport = hero.querySelector('.elementor-main-swiper');
    const track = viewport?.querySelector('.swiper-wrapper');
    const slides = track ? [...track.children] : [];

    if (!slides.length) return;
    hero.dataset.heroFixed = 'true';

    const style = document.createElement('style');
    style.textContent = `
      .carraro-replica .elementor-element-26487302 {
        --hero-columns: 3;
      }
      .carraro-replica .elementor-element-26487302
      .elementor-main-swiper {
        overflow: hidden !important;
        touch-action: pan-y;
      }
      .carraro-replica .elementor-element-26487302
      .swiper-wrapper {
        display: flex !important;
        flex-wrap: nowrap !important;
        gap: 10px !important;
        overflow: visible !important;
        width: 100% !important;
        height: 100% !important;
        transform: translate3d(var(--hero-x, 0px), 0, 0) !important;
        transition: transform .5s ease !important;
      }
      .carraro-replica .elementor-element-26487302
      .swiper-wrapper.hero-reset {
        transition: none !important;
      }
      .carraro-replica .elementor-element-26487302
      .swiper-slide {
        flex: 0 0 calc((100% - 20px) / 3) !important;
        width: calc((100% - 20px) / 3) !important;
        height: 100% !important;
        min-width: 0;
        margin: 0 !important;
      }
      .carraro-replica .elementor-element-26487302
      .elementor-carousel-image {
        display: block !important;
        height: 100% !important;
        background-size: cover;
        background-position: center;
      }
      @media (max-width: 1024px) {
        .carraro-replica .elementor-element-26487302 {
          --hero-columns: 2;
        }
        .carraro-replica .elementor-element-26487302
        .swiper-slide {
          flex-basis: calc((100% - 10px) / 2) !important;
          width: calc((100% - 10px) / 2) !important;
        }
      }
      @media (max-width: 767px) {
        .carraro-replica .elementor-element-26487302 {
          --hero-columns: 1;
        }
        .carraro-replica .elementor-element-26487302
        .swiper-slide {
          flex-basis: 100% !important;
          width: 100% !important;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        .carraro-replica .elementor-element-26487302
        .swiper-wrapper {
          transition: none !important;
        }
      }
    `;
    document.head.appendChild(style);

    const total = slides.length;
    const buffer = Math.min(3, total);
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');

    function clone(slide) {
      const copy = slide.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.removeAttribute('id');
      copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      return copy;
    }

    slides.slice(-buffer).forEach(slide => {
      track.insertBefore(clone(slide), slides[0]);
    });

    slides.slice(0, buffer).forEach(slide => {
      track.appendChild(clone(slide));
    });

    let index = buffer;
    let timer;
    let pending;
    let busy = false;
    let stopped = false;
    let hovering = false;
    let focused = false;
    let pointer;
    let previousWidth = -1;

    const columns = () =>
      Number(getComputedStyle(hero).getPropertyValue('--hero-columns')) || 1;

    function paint(instant = false) {
      track.classList.toggle('hero-reset', instant);

      const step = (viewport.clientWidth + 10) / columns();
      track.style.setProperty('--hero-x', `${-index * step}px`);

      if (instant) {
        void track.offsetWidth;
        track.classList.remove('hero-reset');
      }
    }

    function settle() {
      clearTimeout(pending);

      if (index >= buffer + total) {
        index -= total;
        paint(true);
      } else if (index < buffer) {
        index += total;
        paint(true);
      }

      busy = false;
    }

    function pause() {
      clearInterval(timer);
    }

    function start() {
      pause();

      if (
        stopped || hovering || focused || document.hidden ||
        reduced.matches || total <= columns()
      ) return;

      timer = setInterval(() => {
        if (!hero.isConnected) return pause();
        move(1);
      }, 3000);
    }

    function move(direction, manual = false) {
      if (manual) {
        stopped = true;
        pause();
      }

      if (busy || total <= columns()) return;

      busy = true;
      index += direction;
      paint();

      if (reduced.matches) settle();
      else pending = setTimeout(settle, 560);
    }

    track.addEventListener('transitionend', event => {
      if (event.target === track && event.propertyName === 'transform') {
        settle();
      }
    });

    hero.querySelectorAll('.elementor-swiper-button').forEach(button => {
      const direction = button.classList.contains(
        'elementor-swiper-button-prev'
      ) ? -1 : 1;

      button.tabIndex = 0;
      button.setAttribute('role', 'button');
      button.setAttribute(
        'aria-label',
        direction < 0 ? 'Foto precedente' : 'Foto successiva'
      );

      function activate(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        move(direction, true);
      }

      button.addEventListener('click', activate, true);
      button.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') activate(event);
      }, true);
    });

    hero.addEventListener('mouseenter', () => {
      hovering = true;
      pause();
    });

    hero.addEventListener('mouseleave', () => {
      hovering = false;
      start();
    });

    hero.addEventListener('focusin', () => {
      focused = true;
      pause();
    });

    hero.addEventListener('focusout', event => {
      if (!hero.contains(event.relatedTarget)) {
        focused = false;
        start();
      }
    });

    viewport.addEventListener('pointerdown', event => {
      pointer = { x: event.clientX, y: event.clientY };
      pause();
    });

    viewport.addEventListener('pointerup', event => {
      if (!pointer) return;

      const dx = event.clientX - pointer.x;
      const dy = event.clientY - pointer.y;
      pointer = null;

      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        move(dx < 0 ? 1 : -1, true);
      } else {
        start();
      }
    });

    viewport.addEventListener('pointercancel', () => {
      pointer = null;
      start();
    });

    function layout() {
      if (previousWidth === viewport.clientWidth) return;
      previousWidth = viewport.clientWidth;
      settle();
      paint(true);
      start();
    }

    document.addEventListener('visibilitychange', start);
    reduced.addEventListener?.('change', start);

    if (window.ResizeObserver) {
      new ResizeObserver(layout).observe(viewport);
    } else {
      window.addEventListener('resize', layout);
    }

    layout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHero);
  } else {
    initHero();
  }

  document.addEventListener('shopify:section:load', initHero);
})();